import React, { Component } from 'react'


export default class Url extends Component {

  
    render() {
        return (
            <a href={this.props.info.remote_url} target="_blank" style={{color:"black", textDecoration:"none"}}>
            <div className="card randal shadow">
                <img src={this.props.info.img} className="card-img-top" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{this.props.info.name}</h5>
                    {/* <p className="card-text">{this.props.info.text}</p> */}
                </div>
            </div>
            </a>
        )
    }
}
